import { object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  visitId: string().required(),
  noteId: string().required(),
})

export const url = ({ visitId, noteId }) => `/v1/visits/${visitId}/notes/${noteId}`
